import { useActivityTypesContext } from '../../../context'
import { useMemo } from 'react'

export function useData() {
  const [{ isOpen, current }] = useActivityTypesContext()
  const title = `${current ? 'Update' : 'Create'} Activity`
  const initValues = useMemo(
    () => ({ id: '', name: '', description: '', ...current }),
    [current],
  )

  return {
    isOpen,
    title,
    initValues,
  }
}
